import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domain-specific-dictionaries',
  templateUrl: './domain-specific-dictionaries.component.html',
  styleUrls: ['./domain-specific-dictionaries.component.scss']
})
export class DomainSpecificDictionariesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
